import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import PolicyRuleAppliedItem from './PolicyRuleAppliedItem/PolicyRuleAppliedItem'
import * as Styles from './styles'

const PolicyRulesApplied = ({ policyRules, disabledPolicyRuleId }) => {
  const { t } = useTranslation()

  if (!policyRules?.length) {
    return null
  }

  return (
    <Styles.MainContainer>
      <Text type="titleS">{t('Reglas de política')}</Text>
      <Styles.RulesContainer>
        {policyRules.map(rule => (
          <PolicyRuleAppliedItem key={rule.id} rule={rule} isDisabled={rule.id === disabledPolicyRuleId} />
        ))}
      </Styles.RulesContainer>
    </Styles.MainContainer>
  )
}

export default PolicyRulesApplied
